/**
 * Public app-store links for Zporti. Single source of truth — import these
 * instead of hardcoding store URLs in components.
 */

export const APP_STORE_URL = 'https://apps.apple.com/app/id6772993905';
export const GOOGLE_PLAY_URL =
  'https://play.google.com/store/apps/details?id=com.zporti.app';
